import { Configuration, ContractApi, SpidCheckRequest } from "@api/client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "core/store";
import getConfiguration, { errorHandler } from "core/store/config";

enum WebhookReducer {
	confirmIdentification = "[WEBHOOK] Confirm identification",
}

export const webhookConfirmIdentification = createAsyncThunk<
	void | undefined,
	SpidCheckRequest,
	ThunkApiConfig
>(
	WebhookReducer.confirmIdentification,
	async (request, { dispatch, extra, getState }) => {
		try {
			return await new ContractApi(
				getConfiguration(Configuration, extra, getState)
			).spidCheck(request);
		} catch (e) {
			errorHandler(e, dispatch);
			
			throw e;
		}
	}
);
